import moment from "moment";

export const createRefundStatisticsDownloadDate = type => {
  const currentDate = moment(new Date());
  const month = currentDate.add(type - 1, "months");

  return `${month.format("MM")}_${currentDate.format("YYYY")}`;
};
